import { useOfferCardContext } from '../context/offerCardContext';

export const useGeneralInfo = () => {
  const { generalInfo } = useOfferCardContext();

  return generalInfo;
};
